import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import Button from '../button/Button'
import ButtonsGroup from '../buttonsGroup/ButtonsGroup'
import DataTable from '../dataTable/DataTable'
import DataTableCol from '../dataTable/DataTableCol'
import DataTableHeader from '../dataTable/DataTableHeader'
import DataTableHeaderCol from '../dataTable/DataTableHeaderCol'
import DataTableRow from '../dataTable/DataTableRow'
import Icon from '../icon/Icon'
import ModalBody from '../modal/ModalBody'
import ModalFooter from '../modal/ModalFooter'
import ModalHeader from '../modal/ModalHeader'
import SingleLoader from '../singleLoader/SingleLoader'
import TruncateAndTooltip from '../truncateAndTooltip/TruncateAndTooltip'

// import classNames from 'classnames'

const SelectedRecipientsModal = ({ intl, includedGroups, excludedGroups, appliedFilters, selectedItem, closeCallback, loading, emptyState, error, loadingItems }) => {
  const [elementSelected, setElementSelected] = useState([])
  const [selected, setSelected] = useState(selectedItem)
  const [itemsDisable, setItemsDisable] = useState([])

  useEffect(() => {
    if (selectedItem && !loading) {
      setSelected(selectedItem)
      switch (selectedItem) {
        case 'IncludedGroups':
          setElementSelected(includedGroups)
          break
        case 'ExcludedGroups':
          setElementSelected(excludedGroups)
          break
        case 'AppliedFilters':
          setElementSelected(appliedFilters)
          break
      }
    }
  }, [selectedItem.length > 0])

  useEffect(() => {
    const ret = []
    if (includedGroups.length === 0) {
      ret.push('IncludedGroups')
    }
    if (excludedGroups.length === 0) {
      ret.push('ExcludedGroups')
    }
    if (appliedFilters.length === 0) {
      ret.push('AppliedFilters')
    }
    setItemsDisable(ret)
  }, [includedGroups, excludedGroups, appliedFilters])

  const buttonGroupItems = [{
    label: intl.formatMessage({ id: 'Load.Statistics.IncludedGroups' }) + ' (' + includedGroups.length + ')',
    data: 'IncludedGroups'
  }, {
    label: intl.formatMessage({ id: 'Load.Statistics.ExcludedGroups' }) + ' (' + excludedGroups.length + ')',
    data: 'ExcludedGroups'
  }, {
    label: intl.formatMessage({ id: 'Load.Statistics.AppliedFilters' }) + ' (' + appliedFilters.length + ')',
    data: 'AppliedFilters'
  }]

  function callbackButtonsGroup(title) {
    setSelected(title)
    switch (title) {
      case 'IncludedGroups':
        setElementSelected(includedGroups)
        break
      case 'ExcludedGroups':
        setElementSelected(excludedGroups)
        break
      case 'AppliedFilters':
        setElementSelected(appliedFilters)
        break
    }
  }

  const propsBtnCloseModal = {
    children: intl.formatMessage({ id: 'Load.Common.Close' }),
    kind: 'secondary',
    onClick: closeCallback,
    className: 'test-SelectedRecipientsModal-closeModal f-right'
  }

  return (
    <>
      {loading ? <SingleLoader height='200px' /> : <>
        <ModalHeader>
          <h2 className='frontend-p-bottom'>{intl.formatMessage({ id: 'Load.Statistics.SendTargeting' })}</h2>
          {!emptyState && <ButtonsGroup className='text-center test-SelectedRecipientsModal-ButtonsGroup' itemSelected={selected} items={buttonGroupItems} callback={callbackButtonsGroup} itemsDisable={itemsDisable} />}
        </ModalHeader>
        <ModalBody>
          {loadingItems
            ? <SingleLoader height='200px' />
            : error
              ? <>
                <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
                <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>
              </>
              : <>
                {emptyState
                  ? <i className='frontend-text-center'>{intl.formatMessage({ id: 'Load.SendReportFrontend.NoDataModalGroupFilter' })}</i>
                  : <>

                    <DataTable>
                      <DataTableHeader> <DataTableHeaderCol width='12'>{intl.formatMessage({ id: 'Load.Statistics.' + selected })}</DataTableHeaderCol></DataTableHeader>

                      {elementSelected.length === 1
                        ? <DataTableRow>
                          <DataTableCol width='12'>
                            {elementSelected[0].text ? <TruncateAndTooltip text={<><strong>{elementSelected[0].id}</strong> - {elementSelected[0].text}</>} /> : <p className='is-loading' />}
                          </DataTableCol>
                        </DataTableRow>
                        : <>
                          {elementSelected.reduce(function (acc, item, i, arr) {
                            if ((i + 1) % 2 === 0) return acc
                            acc.push(
                              <DataTableRow key={i}>
                                <DataTableCol width='6' className='frontend-p-right'>{item.text ? <TruncateAndTooltip text={<><strong>{item.id}</strong> - {item.text}</>} /> : <p className='is-loading' />}</DataTableCol>
                                {arr[i + 1] !== undefined &&

                                  <DataTableCol width='6'>{arr[i + 1].text ? <TruncateAndTooltip text={<><strong>{arr[i + 1].id}</strong> - {arr[i + 1].text}</>} /> : <p className='is-loading' />}</DataTableCol>}
                              </DataTableRow>
                            )
                            return acc
                          }, [])}
                        </>}

                    </DataTable>
                  </>}
              </>}
        </ModalBody>
        <ModalFooter>
          <Button {...propsBtnCloseModal} />
        </ModalFooter>
      </>}
    </>

  )
}

SelectedRecipientsModal.defaultProps = {
}

SelectedRecipientsModal.propTypes = {

  includedGroups: PropTypes.array,
  excludedGroups: PropTypes.array,
  appliedFilters: PropTypes.array,
  selectedItems: PropTypes.string
}

export default injectIntl(SelectedRecipientsModal)
